import { CustomAlarmDefinitionAPI } from 'modules/settings/pods/settings-devices/settings-devices-configuration/service/custom-alarm-definition.api';
import { mapCustomAlarmDefinitionFromApi } from 'modules/settings/pods/settings-devices/settings-devices-configuration/service/custom-alarm-definition.mapper';
import { CustomAlarmDefinition } from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';

export const mapCustomAlarmDefinitionsFromApi = (alarms: CustomAlarmDefinitionAPI[]): CustomAlarmDefinition[] =>
    alarms.map(mapCustomAlarmDefinitionFromApi);
